import api from '@/api';
import { saveParamsToQuery } from '@/utils/helpers';

let currentTicketListRequest = null;

const receiptOrder = {
  namespaced: true,

  state() {
    return {
      isLoading: false,
      request: {},
      customer: {},
      contractor: {},
      supplierId: null,
      storage: '',
      nomenclatures: [],
      supplierList: [],
      object: '',
      items: [],
      files: [],
      itemsErrors: [],
      list: {
        receiptOrders: [],
        pageCount: 0,
        page: 0,
      },
    };
  },

  mutations: {
    changeLoading(state, status) {
      state.isLoading = status;
    },
    setRequest(state, data) {
      state.request = data;
    },
    setCustomer(state, data) {
      state.customer = data;
    },
    setContractor(state, data) {
      state.contractor = data;
    },
    setSupplier(state, data) {
      state.supplier = data;
    },
    setFiles(state, files) {
      state.files = files;
    },
    setSupplierList(state, list) {
      state.supplierList = list.map((item) => ({ title: item.name, key: item.id }));
    },
    setSupplierId(state, id) {
      state.supplierId = id;
    },
    setStorage(state, storage) {
      state.storage = storage;
    },
    setObject(state, object) {
      state.object = object;
    },
    setNomenclatures(state, data) {
      state.nomenclatures = data;
    },
    setPage(state, page) {
      state.list.page = page;
    },
    setSearch(state, value) {
      state.search = value;
    },
    setList(state, data) {
      state.list = { ...data.result };
    },
    setItemsErrors(state, error) {
      state.itemsErrors = error;
    },
  },
  actions: {
    async saveReceiptOrder({
      state, commit, dispatch, rootState,
    }, { items }) {
      commit('changeLoading', true);
      items = items.filter((item) => item.id);
      try {
        const { isLoggedIn } = rootState.user;

        if (!isLoggedIn) {
          return;
        }
        const params = {
          id: state.request.id,
          supplierId: state.supplierId,
          files: state.files.map((file) => file.id),
          items,
        };
        await api.receiptOrder.save(params);
        commit('setItemsErrors', []);
      } catch (e) {
        if (e.response.data?.description) {
          commit('setItemsErrors', [e.response.data.description]);
        }
        console.log(e);
      } finally {
        commit('changeLoading', false);
      }
    },
    async loadByRequestId({ commit, dispatch }, { id }) {
      commit('changeLoading', true);
      try {
        const { data } = await api.receiptOrder.getSupplier(id);
        dispatch('setReceiptOrderResult', data.result);
      } catch (e) {
        console.log(e);
      } finally {
        commit('changeLoading', false);
      }
    },
    async getAvailableItemsOnSupplier({ commit, dispatch }, { id, supplierId }) {
      commit('changeLoading', true);
      try {
        const { data } = await api.receiptOrder.getAvailableItemsOnSupplier(id, supplierId);
        commit('setNomenclatures', data.result.items);
      } catch (e) {
        console.log(e);
      } finally {
        commit('changeLoading', false);
      }
    },
    setReceiptOrderResult({ commit }, result) {
      commit('setRequest', result.supplyRequest || result.request);
      commit('setCustomer', result.customer);
      commit('setContractor', result.contractor);
      commit('setSupplierId', result.supplier?.id);
      commit('setSupplierList', result.supplier ? [result.supplier] : result.supplierList);
      commit('setStorage', `${result.storage.title} (${result.storage.address})`);
      commit('setObject', `${result.object.title} (${result.object.address})`);
      commit('setNomenclatures', result.items);
      commit('setFiles', result.files);
    },
    resetDetailsState({ commit }) {
      commit('setRequest', {});
      commit('setCustomer', {});
      commit('setContractor', {});
      commit('setSupplierId', null);
      commit('setSupplierList', []);
      commit('setStorage', '');
      commit('setObject', '');
      commit('setNomenclatures', []);
      commit('setFiles', []);
    },
    async loadList({
      state, commit, rootState, rootGetters,
    }) {
      commit('changeLoading', true);

      try {
        if (currentTicketListRequest) {
          return;
        }
        const { isLoggedIn } = rootState.user;
        const role = rootGetters['user/getPriorityRole']('contractor');

        if (!role && isLoggedIn) {
          return;
        }

        const params = {
          pageSize: 10,
          page: state.list.page,
          search: state.search,
        };
        // ToDo тут другое API и нужно будет проверить возвращаемую стурктуру и структуру в state
        currentTicketListRequest = api.supplyRequest[role].list(params);
        const { data } = await currentTicketListRequest;
        saveParamsToQuery({ page: params.page, search: params.search });
        commit('setList', data);
        currentTicketListRequest = null;
      } catch (e) {
        currentTicketListRequest = null;
        console.log(e);
      }
      commit('changeLoading', false);
    },
    async setSearch({ commit, dispatch }, value) {
      commit('setSearch', value);
      commit('setPage', 1);
      await dispatch('loadList');
    },
    async setPage({ commit, dispatch }, page) {
      commit('setPage', page);
      await dispatch('loadList');
    },
  },
  getters: {
    getSupplier: (state) => {
      const id = state.supplierId;
      return state.supplierList?.find((supplier) => supplier.id === Number(id));
    },
  },
};

export default receiptOrder;
